const nameWithDocumentByArrayObject = (array) => {
  const newArray = []

  array?.map((obj) => {
    let doc = obj?.document ? ` - ${obj?.document}` : ''
    if (!obj.name.includes(obj?.document)) {
      obj.name = `${obj.name}${doc}`
    }
    newArray.push(obj)

    return obj.name
  })
  return newArray
}

const nameWithDocument = {
  nameWithDocumentByArrayObject,
}

export default nameWithDocument
